module.exports = __webpack_public_path__ + "2c2a986290154fbea638d7bbe050da9a.jpg";